<template>
  <apexchart
    type="bar"
    height="300"
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>

<script>
import { bus } from "../../../../main";
import { defineComponent } from "@vue/composition-api";
import VueApexCharts from "vue-apexcharts";
//import apifactory from '../../api';
export default defineComponent({
  setup() {},
  props: {
    ctrldata: [],
  },
  components: {
    apexchart: VueApexCharts,
  },

  data: () => ({
    tempctrldata: [],
    item_roi_total: [],
    item_roi_current: [],
    item_roi_privious: [],
    Item_Category: [],
    series: [],
    chartOptions: {
            chart: {
                type: 'bar',
                height: 350,
                fontFamily: 'Lato',
                toolbar: {
                    show: false
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    endingShape: 'rounded',
                    borderRadius: 8
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },

            yaxis: {
                categories: [],
                labels: {
                  style: {
                    colors: ["#9AA1A9"],
                  },
                  formatter: val => new Intl.NumberFormat('en').format(val)
                },
            },
            xaxis: {
                labels: {
                  style: {
                    colors: "#9AA1A9",
                    fontWeight: 'bold'
                  },
                },
            },
            fill: {
                opacity: 1
            },

            tooltip: {
                y: {
                formatter: val => new Intl.NumberFormat('en').format(val)
                }
            },
            labels: {
                enabled: false
            },
            grid: {
                show: false, // you can either change hear to disable all grids
                xaxis: {
                    show: true
                },
                yaxis: {
                    lines: {
                        show: false //or just here to disable only y axis
                    }
                },
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right'
            }
        },
  }),
  methods: {
    getroi_total() {
      this.item_roi_total = [];
      let tempdata1 = this.tempctrldata.roi_total;
      for (var i = 0; i < tempdata1.length; i++) {
        if (tempdata1[i].region == "national") {
          if (tempdata1[i].variable != "base") {
          this.item_roi_total.push(tempdata1[i].volume);}
        }
      }
      this.getroi_current();
    },
    getroi_current() {
      this.item_roi_current = [];
      this.Item_Category = [];
      let tempdata1 = this.tempctrldata.roi_current;
      for (var i = 0; i < tempdata1.length; i++) {
        if (tempdata1[i].region == "national") {
          if (tempdata1[i].variable != "base") {
          this.item_roi_current.push(tempdata1[i].volume);
          this.Item_Category.push(tempdata1[i].variable);}
        }
      }
      this.getroi_privious();
    },
    getroi_privious() {
      this.item_roi_privious = [];
      let tempdata1 = this.tempctrldata.roi_previous;
      for (var i = 0; i < tempdata1.length; i++) {
        if (tempdata1[i].region == "national") {
          if (tempdata1[i].variable != "base") {
          this.item_roi_privious.push(tempdata1[i].volume);}
        }
      }
      this.binddata();
    },

    binddata() {
      this.series = [
        {
          name: "Total Period",
          data: this.item_roi_total,
        },
        {
          name: "Current Period",
          data: this.item_roi_current,
        },
        {
          name: "Previous Period",
          data: this.item_roi_privious,
        },
      ];
      this.chartOptions = {
        xaxis: {
          categories: this.Item_Category,
        },
      };
    },

    refresh() {
      // alert('refreshChartBarRoi');
      this.getroi_total();
    },
  },
  mounted() {
    this.tempctrldata = this.ctrldata;
    this.getroi_total();
      bus.$off('refreshChartBarVolumne');
        // alert('dd');
        bus.$on('refreshChartBarVolumne', this.refresh);
  },
  watch: {
    ctrldata: function (val) {
      // alert('Onoad -' + val);
      if (val) {
        this.tempctrldata = this.ctrldata;
        this.getroi_total();
      }
    },
  },
});
</script>
